import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { medicosCarga, estadosCarga, municipiosCarga, especialidadesCarga, circulosCarga, actualizaFlagMarcadores } from './directorio.act';

const mapState = (state) => {
	return {
		estados: state.directorio.estados,
		municipios: state.directorio.municipios,
		//listaMedicos: state.directorio.listaMedicos,
		initialValues: state.directorio.medicos,
        especialidades: state.directorio.especialidades,
        circulos: state.directorio.circulos,
        finalizo: state.directorio.finalizo,
        marcadoresFlag: state.directorio.marcadoresFlag
	};
}

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		cargaEstados: () => {
			dispatch(estadosCarga())
		},
		cargaMunicipios: (_idEstado) => {
			dispatch(municipiosCarga(_idEstado))
		},
        cargaEspecialidades: () => {
            dispatch(especialidadesCarga())
        },
        cargaCirculos: (contrato) => {
        	dispatch(circulosCarga(contrato))
        },
		guardarDatos(oData) {
			dispatch({ "type" : "DIRECTORIO_MEDICOS_FORM", "medicos": oData });
		},
		guardaItemSeleccionado: () => {
			dispatch({ "type": "DIRECTORIO_OPCIONAL", "opcional": {}})
		},
        cambioFinalizo: () => {
            dispatch({ "type": "DIRECTORIO_FINALIZO", "finalizo": false });
        },
        cambiaFlagMarcadores: (_paso) => {
            dispatch(actualizaFlagMarcadores(_paso));
        },
        tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	}
}

const validate = (campos) => {
	const errors = {};

	if(!campos.estado) {
		errors.estado = 'Campo requerido.';
	}

	if(!campos.municipio) {
		errors.municipio = 'Campo requerido.';
	}

	if(!campos.especialidad) {
		errors.especialidad = 'Campo requerido.';
	}

	if(!campos.circulo) {
		errors.circulo = 'Campo requerido.';
	}	

	return errors;
}

const renderSelectField = ({ input, label, type, meta: { touched, error }, children }) => (
	<div>
		<select id="dd" {...input}>
			{children}
		</select>
		{touched && (error && 
			<div>
				<div className='msj-error'>
					<p><span>{error}</span></p>
				</div>
			</div>)
		}
	</div>
)

class MedicosForm extends React.Component {

	data = {
		contratacion:'general',
		estado:'0',
		municipio:'0',
		especialidad:'0',
		circulo:'0'
	}

	componentWillMount = () => {
		/*if(this.props.listaMedicos.length == 0) {
			this.props.cargaMedicos();
		}*/
		if(this.props.estados.length == 0) {
			this.props.cargaEstados();
		}
        if(this.props.especialidades.length == 0){
            this.props.cargaEspecialidades();
        }
        if(this.props.circulos.length == 0){
        	this.props.cargaCirculos("general");
        }
		this.data = JSON.parse(JSON.stringify(this.props.initialValues));
		this.props.guardaItemSeleccionado();
        this.props.cambioFinalizo();
        this.props.cambiaFlagMarcadores(1);
	}
	
	selectFiltro = (_tipo, e) => {
		let valor = e.target.selectedOptions ? e.target.selectedOptions[0].value : e.target.defaultValue;
		this.data[_tipo] = valor;

		if(_tipo == "nombre"){
			this.data.nombre = e.target.value;
		}

		if(_tipo == "apaterno"){
			this.data.apaterno = e.target.value;
		}

		if(_tipo == "amaterno"){
			this.data.amaterno = e.target.value;
		}
		
		if(_tipo == "estado") {
			this.data.municipio = "0";
			if(this.data.contratacion == "general"){
				this.props.tagManager({ "type": "EVENT_DIRMED_INDIVIDUAL-ESTADO" });
			}
			else if(this.data.contratacion == "empresarial"){
				this.props.tagManager({ "type": "EVENT_DIRMED_COLECTIVO-ESTADO" });
			}
		}
		
		this.props.guardarDatos(JSON.parse(JSON.stringify(this.data)));
		
		if(_tipo == "estado") {
			this.props.cargaMunicipios(valor);
			this.props.change("municipio", "0");
		}

		if(_tipo == "contratacion"){
			this.props.cargaCirculos(e.target.value);
			//console.log(e.target.value);
            this.props.change("plan", "0");
            this.props.change("estado", "0");
            this.props.change("municipio", "0");
            //this.data.municipio = "0";
            //this.data.estado = "0";
            //this.data.plan = "0";
        }
        
        if(_tipo == "municipio"){
        	if(this.data.contratacion == "general"){
				this.props.tagManager({ "type": "EVENT_DIRMED_INDIVIDUAL-MUNICIPIO" });
			}
			else if(this.data.contratacion == "empresarial"){
				this.props.tagManager({ "type": "EVENT_DIRMED_COLECTIVO-MUNICIPIO" });
			}
        }
        
        if(_tipo == "especialidad"){
        	if(this.data.contratacion == "general"){
				this.props.tagManager({ "type": "EVENT_DIRMED_INDIVIDUAL-ESPECIALIDAD" });
			}
			else if(this.data.contratacion == "empresarial"){
				this.props.tagManager({ "type": "EVENT_DIRMED_COLECTIVO-ESPECIALIDAD" });
			}
        }
        
        if(_tipo == "circulo"){
        	if(this.data.contratacion == "general"){
				this.props.tagManager({ "type": "EVENT_DIRMED_INDIVIDUAL-CIRCULO" });
			}
        }
	}

	verificaContrato(dato){
		let clase = "";
		if(dato == "empresarial"){
			clase = "hide";
		}

		return clase;
	}
	
	render () {
		const { handleSubmit, submitting } = this.props;
		return (
			<form onSubmit={handleSubmit} style={{"marginTop":"40px"}}>
                <h5>Médicos en convenio</h5>
				<div className="input-wrap">
					<label className="txt-gray">En esta sección podrás visualizar la información de los médicos en convenio con GNP Seguros. Selecciona la manera en la que obtuviste tu seguro y los datos para realizar tu consulta.</label>
					<hr />
					<div className="checkbox-blue">
						<div className="blu-input-radio">
							<Field name="contratacion" component="input" type="radio" value="general" onChange={this.selectFiltro.bind(this, "contratacion")}/>
							<label></label>
						</div>
						<span>La póliza de Gastos Médicos Mayores fue contratada a través de un Asesor Profesional de Seguros (Póliza familiar o individual) o Tienda Departamental.</span>
					</div>
					<div className="checkbox-blue">
						<div className="blu-input-radio">
							<Field name="contratacion" component="input" type="radio" value="empresarial" onChange={this.selectFiltro.bind(this, "contratacion")}/>
							<label></label>
						</div>
						<span>La póliza de Gastos Médicos Mayores es una prestación empresarial o bien, fue contratada a través de una empresa para contar con mayores beneficios (Seguro Colectivo).</span>   
					</div>
					<hr />
					<label className="blue-text">Recuerda: En caso de requerir hospitalización, es importante verificar los hospitales a los que tienes acceso de acuerdo al plan contratado, y confirmar con el médico que pueda brindar la atención en el hospital elegido, con la finalidad de no generar costos adicionales.</label>
				</div>
				
				<div className="input-wrap">
					<label>Estado*</label>
					<span className="clearfix">
                        <Field name="estado" component={renderSelectField} onChange={this.selectFiltro.bind(this, "estado")}>
                            <option value="0">Todos</option>
                            { this.props.estados.map((option, i) => 
                                <option value={option.idestado} key={i}>{option.nombre}</option>
                            )}
                        </Field>
					</span>
				</div>
				
				<div className="input-wrap">
					<label>Delegación o Municipio</label>
					<span className="clearfix">
                        <Field name="municipio" component={renderSelectField} onChange={this.selectFiltro.bind(this, "municipio")}>
                            <option value="0">Todos</option>
                            { this.props.municipios.map((option, i) => 
                                <option value={option.idmunicipio} key={i}>{option.nombre}</option>
                            )}
                        </Field>
					</span>
				</div>

				<div className="input-wrap">
					<label>Especialidad*</label>
					<span className="clearfix">
						<Field name="especialidad" component={renderSelectField} onChange={this.selectFiltro.bind(this, "especialidad")}>
							<option value="0">Todos</option>
							{ this.props.especialidades.map((option, i) => 
                                <option value={option.idespecialidad} key={i}>{option.nombre}</option>
                            )}
						</Field>
					</span>
				</div>

				<div className={"input-wrap "+this.verificaContrato(this.data.contratacion)}>
					<label>Círculo*</label>
					<span className="clearfix">
						<Field name="circulo" component={renderSelectField} onChange={this.selectFiltro.bind(this, "circulo")}>
							<option value="0">Todos</option>
							{ this.props.circulos.map((option, i) => 
                                <option value={option.idcirculo} key={i}>{option.nombre}</option>
                            )}
						</Field>
					</span>
				</div>

				<div className="input-wrap medico-input-wrap">
					<label>Nombre del médico</label>
					<span className="clearfix">
						<div>
							<Field name="nombre" component='input' onInput={this.selectFiltro.bind(this, "nombre")} className="directorio-wrap input-wrap select medico-data-input" />
						</div>
					</span>
				</div>

				<div className="input-wrap medico-input-wrap">
					<label>Apellido Paterno</label>
					<span className="clearfix">
						<div>
							<Field name="apaterno" component='input' onInput={this.selectFiltro.bind(this, "apaterno")} className="directorio-wrap input-wrap select medico-data-input" />
						</div>
					</span>
				</div>

				<div className="input-wrap medico-input-wrap">
					<label>Apellido Materno</label>
					<span className="clearfix">
						<div>
							<Field name="amaterno" component='input' onInput={this.selectFiltro.bind(this, "amaterno")} className="directorio-wrap input-wrap select medico-data-input" />
						</div>
					</span>
				</div>

				<div className="input-wrap medico-input-wrap">
					<label className="orange-text"><b>* </b></label>
					<label className="blue-text"><b>Campo obligatorio</b></label>

					<label className="txt-gray">Todos los resultados incluyen al Grupo Médico Optime. Puedes realizar la búsqueda con los filtros generales (Estado, Círculo y Especialidad) o bien, de forma particular, ingresando el estado y nombre del médico.</label>

					<label className="txt-gray">Si desconoces el Círculo Médico contratado en la póliza, llama al: 55 5227 9000 para la CDMX y 01 (55) 5227 9000 para el interior de la República.</label>
				</div>
				
				<button className='orange-btn' type="submit" style={{"margin":"10px auto","display":"inherit"}}>
					Buscar
				</button>
			</form>
		)
	}
}

MedicosForm = reduxForm({form: 'directorio-medicos', validate})(MedicosForm);
export default connect(mapState, mapDispatch)(MedicosForm);


// WEBPACK FOOTER //
// ./src/directorio/medicos.frm.js